import { Module } from "vuex";
import { actions, ADDRESS_LOOKUP_ACTIONS } from "./actions";
import { getters, ADDRESS_LOOKUP_GETTERS } from "./getters";
import { mutations, ADDRESS_LOOKUP_MUTATIONS } from "./mutations";
import { IAddressLookupState, IAddressLookupProgress } from "./types";
import { IRootState } from "@/store/types";
import { cloneDeep } from "@/helpers/object";

export const emptyAddress = {
  dpid: "",
  fullAddress: "",
  sourceDesc: ""
};

export const initialProgress: IAddressLookupProgress = {
  inProgress: false,
  hasLoaded: false,
  hasError: false,
  success: false,
  errorMessages: []
};

export const errorProgress: IAddressLookupProgress = {
  inProgress: false,
  hasLoaded: true,
  hasError: true,
  success: false,
  errorMessages: []
};

export const requestProgress: IAddressLookupProgress = {
  inProgress: true,
  hasLoaded: false,
  hasError: false,
  success: false,
  errorMessages: []
};

export const successProgress: IAddressLookupProgress = {
  inProgress: false,
  hasLoaded: true,
  hasError: false,
  success: true,
  errorMessages: []
};

export const state: IAddressLookupState = {
  isManual: {
    delivery: false,
    physical: false,
    residential: false
  },
  responses: {
    delivery: [],
    physical: [],
    residential: []
  },
  progress: {
    delivery: {
      ...initialProgress
    },
    physical: {
      ...initialProgress
    },
    residential: {
      ...initialProgress
    }
  }
};

export namespace ADDRESS_LOOKUP {
  export const ACTIONS = ADDRESS_LOOKUP_ACTIONS;
  export const GETTERS = ADDRESS_LOOKUP_GETTERS;
  export const MUTATIONS = ADDRESS_LOOKUP_MUTATIONS;
  export const NAME_SPACE = "addressLookup";
  export const NS = (x: string): string => `${NAME_SPACE}/${x}`;
}

const namespaced: boolean = true;

export const addressLookup: Module<IAddressLookupState, IRootState> = {
  namespaced,
  state: cloneDeep(state), // create a deep clone of state object so we can reuse the state object
  getters,
  actions,
  mutations
};
